import React, { useContext } from "react";
import { staticContext } from "../context";

const useStaticContext = () => {
	return useContext(staticContext);
};

export default useStaticContext;
